import type { MemberPermission } from '@elecmap/api/src/base.d'

export function checkSpacePermission(
  role: MemberPermission | null,
  canManage: boolean,
  spaceType: string,
) {
  if (canManage) return true
  return role !== 'viewer' || spaceType === '1'
}

export function getDisabledProjectPermission(
  spaceRole: MemberPermission | null,
  projectRole: MemberPermission | null,
  canManage: boolean,
  spaceType: string,
): string[] {
  const spacePermission = checkSpacePermission(spaceRole, canManage, spaceType)
  if (spacePermission || projectRole === 'owner') return []
  const ret: string[] = []
  if (projectRole === 'manager') {
    ret.push('delete')
  } else if (projectRole === 'editor' || spaceRole === 'editor') {
    ret.push('rename', 'permission', 'move', 'delete')
  } else {
    ret.push('toDesign', 'rename', 'permission', 'copy', 'move', 'delete')
  }

  return ret
}
